import React, { useState, useEffect } from "react";
import axios,{AxiosRequestHeaders} from "axios";
import loaderimage from "../../images/giphy.gif";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../shared/ConfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import { Badge, Modal, Button } from "react-bootstrap";
import { format } from "date-fns";


const Interviews: React.FC = () => {
    const [interviewList, setInterviewList] = useState<any[]>([]);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [filteredInterviews, setFilteredInterviews] = useState<any[]>([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const[successMessage, setSuccessMessage] = useState("");
    const [failureMessage, setFailureMessage] = useState("");
    const [showFailureModal, setShowFailureModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [cancelingId, setCancelingId] = useState<string | null>(null);
    const [selectedInterviewId, setSelectedInterviewId] = useState<string | null>(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedInterview, setSelectedInterview] = useState<any>(null);
    const navigate = useNavigate();
    // Pagination state
      const [currentPage, setCurrentPage] = useState(1);
      const [totalPages, setTotalPages] = useState(0);
      const [totalCandidates, setTotalCandidates] = useState(0);
      const [pageSize, setPageSize] = useState(100);
    const formatDate = (dateString: string) => {
        try {
            return format(new Date(dateString), 'MMM dd, yyyy');
        } catch (error) {
            return dateString;
        }
    };

    const formatTime = (timeString: string) => {
        try {
            const [hours, minutes] = timeString.split(':');
            return `${Number(hours) % 12 || 12}:${minutes} ${Number(hours) >= 12 ? 'PM' : 'AM'}`;
        } catch (error) {
            return timeString;
        }
    };
    const headers: AxiosRequestHeaders = {
        'x-access-token': localStorage.getItem('jwttoken') || '',
      };
    const fetchInterviewList = async (page = 1) => {
        try {
            setLoader(true);
            setError(null);
            const url = `${process.env.REACT_APP_API_URL}interviews/interviewDetails?page=${page}&limit=100`;
            const response = await axios.get(url,{ headers });
            setInterviewList(response.data.interviews || response.data);
            setFilteredInterviews(response.data.interviews || response.data);
            setTotalPages(response.data.totalPages || 1);
            setTotalCandidates(response.data.totalCandidates || (response.data.length || 0));
            setCurrentPage(response.data.currentPage || page);
        } catch (error: any) {
            setError("Failed to fetch interviews.");
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchInterviewList();
    }, []);

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
    };

    useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            if (searchTerm === "") {
                setFilteredInterviews(interviewList);
            } else {
                const filtered = interviewList.filter(
                    (interview) =>
                        interview?.username?.toLowerCase().includes(searchTerm) ||
                        interview?.name?.toLowerCase().includes(searchTerm) ||
                        interview?.company_name?.toLowerCase().includes(searchTerm)
                );
                setFilteredInterviews(filtered);
            }
        }, 300);
        return () => clearTimeout(debounceTimeout);
    }, [searchTerm, interviewList]);

    const handleReschedule = (interviewId: string) => {
        navigate(`/interviewreschedule?interviewId=${interviewId}`); // Navigate to InterviewReschedule.tsx
    };

    const handleCancelInterview = (interviewId: string) => {
        setModalMessage("Are you sure you want to cancel this interview?");
        setSelectedInterviewId(interviewId);
        setShowModal(true);
    };

    const handleConfirmCancel = async () => {
        if (!selectedInterviewId) return;

        setCancelingId(selectedInterviewId);
        setShowModal(false);

        try {
            const url = `${process.env.REACT_APP_API_URL}interviews/cancel/${selectedInterviewId}`;
            await axios.get(url);
            setSuccessMessage("Interview canceled successfully!");
            setShowSuccessModal(true);
            setTimeout(() => {
                setShowSuccessModal(false);
                fetchInterviewList(); 
                }, 2000);
            setInterviewList((prev) =>
                prev.map((item) =>
                    item.interviewId === selectedInterviewId ? { ...item, status: "canceled" } : item
                )
            );
        } catch (error) {
            setFailureMessage("Failed to cancel interview. Please try again.");
            setShowFailureModal(true);
        } finally {
            setCancelingId(null);
            setSelectedInterviewId(null);
        }
    };

    const handleViewDetails = (interview: any) => {
        setSelectedInterview(interview);
        setShowViewModal(true);
    };
    const handlePageChange = (page: number) => {
        fetchInterviewList(page);
      };

      const startEntry = (currentPage - 1) * 100 + 1;
  const endEntry = Math.min(currentPage * 100, totalCandidates);

    return (
        <div className="">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="text-dark fw-bold">Interview Management</h2>
                <div className="d-flex gap-2 align-items-center" style={{ width: "510px" }}>
                    <span className="fw-bold text-secondary text-nowrap">{filteredInterviews.length} results</span>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Name, Username, or Company"
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </div>
            </div>
            <div className="card shadow-sm border-0 rounded">
                <div className="card-header bg-info border-bottom py-3">
                    <h5 className="mb-0 text-white">Interview List</h5>
                </div>
                <div className="card-body p-0">
                    <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <table className="table table-hover align-middle mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th>#</th>
                                    <th>User ID</th>
                                    <th>Username</th>
                                    <th>Name</th>
                                    <th>Company Name</th>
                                    <th>Job Title</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loader ? (
                                    <tr>
                                        <td colSpan={10} className="text-center py-2">
                                            <img src={loaderimage} alt="Loading..." height="40" />
                                        </td>
                                    </tr>
                                ) : error ? (
                                    <tr>
                                        <td colSpan={10} className="text-center text-danger fw-bold py-3">
                                            <div className="alert alert-danger text-center m-3" role="alert">
                                                Oops! Something went wrong. Please try again later.
                                            </div>
                                        </td>
                                    </tr>
                                ) : filteredInterviews.length > 0 ? (
                                    filteredInterviews.map((item, index) => (
                                        <tr
                                            key={index}
                                            className="border-bottom"
                                            onClick={(e) => {
                                                if (!(e.target as HTMLElement).closest(".action-buttons")) {
                                                    handleViewDetails(item);
                                                }
                                            }}
                                            style={{ cursor: "pointer" }}>
                                            <td>{index + 1}</td>
                                            <td>{item.userid}</td>
                                            <td>{item.username}</td>
                                            <td>{item.name}</td>
                                            <td>{item.company_name}</td>
                                            <td>{item.job_name}</td>
                                            <td>{formatDate(item.date)}</td>
                                            <td>{formatTime(item.time)}</td>
                                            <td><Badge bg={item.status === "accepted" ? "success" : item.status === "scheduled" ? "warning" : "danger"}>{item.status}</Badge></td>
                                            <td className="text-center">
                                                <div className="d-flex justify-content-center gap-2">
                                                    <button className="btn btn-sm btn-outline-primary" onClick={() => handleViewDetails(item)}>View</button>
                                                    <button
                                                        className="btn btn-sm btn-outline-warning"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleReschedule(item.interviewId)
                                                        }}
                                                    >
                                                        Reschedule
                                                    </button>
                                                    <div onClick={(e) => e.stopPropagation()}>
                                                        {(
                                                            <button
                                                                className="btn btn-sm btn-outline-secondary"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleCancelInterview(item.interviewId)
                                                                }
                                                                }
                                                                disabled={(cancelingId === item.interviewId) || (item.status !== "canceled")}
                                                            >
                                                                {cancelingId === item.interviewId ? "Canceling..." : "Cancel"}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))) : (
                                    <tr>
                                        <td colSpan={10} className="text-center  text-muted fw-bold">
                                            <div className="alert alert-secondary text-center m-3" role="alert">
                                                No Interviews available
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* Pagination */}
              <div className="position-sticky bottom-0 bg-white py-2 border-top">
            <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted ps-3">
                    Showing {startEntry}-{endEntry} of {totalCandidates} entries
                  </div>
                  <nav>
                    <ul className="pagination mb-0 pe-3">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages)].map((_, index) => (
                        <li 
                          key={index} 
                          className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                        >
                          <button 
                            className="page-link" 
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button 
                          className="page-link" 
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
                </div>
            </div>


            <ConfirmationModal
                show={showModal}
                onHide={() => setShowModal(false)}
                modalMessage={modalMessage}
                operationType="Confirm"
                confirmation={handleConfirmCancel}
            />
    <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="OK" timeoutDuration={3000} />
                 <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage} operationType="OK" timeoutDuration={5000} />

            <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered>
                <Modal.Header className="p-0 border-0">
                    <div className="w-100 px-3 py-3 d-flex justify-content-between align-items-center">
                        <h4 className="fw-bold text-primary m-0">Interview Details</h4>

                        <div className="d-flex align-items-center gap-2 me-2">
                            <Button variant="danger" size="sm" onClick={() => setShowViewModal(false)}>
                                ✖
                            </Button>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="p-0">
                    {selectedInterview && (
                        <div className="border border-secondary rounded shadow-sm p-4 mx-4 mb-2">
                            <div className="d-flex flex-column gap-3">
                                <div className="d-flex justify-content-between">
                                    <span className="fw-bold text-secondary">Name:</span>
                                    <span className="text-dark">{selectedInterview.name}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="fw-bold text-secondary">Company:</span>
                                    <span className="text-dark">{selectedInterview.company_name}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="fw-bold text-secondary">Job Name:</span>
                                    <span className="text-dark">{selectedInterview.job_name}</span>
                                </div>
                                {selectedInterview.location !== "Remote" && (
                                    <>
                                        {selectedInterview.location && (
                                            <div className="d-flex justify-content-between">
                                                <span className="fw-bold text-secondary">Office Location: </span>
                                                <span className="text-dark">{selectedInterview.location}</span>
                                            </div>
                                        )}
                                        {selectedInterview.location && (
                                            <div className="d-flex justify-content-between">
                                                <span className="fw-bold text-secondary">Interview Venue: </span>
                                                <span className="text-dark">{selectedInterview.location}</span>
                                            </div>
                                        )}
                                    </>
                                )}

                                <div className="d-flex justify-content-between">
                                    <span className="fw-bold text-secondary">Date:</span>
                                    <span className="text-dark">{formatDate(selectedInterview.date)}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="fw-bold text-secondary">Time:</span>
                                    <span className="text-dark">{formatTime(selectedInterview.time)}</span>
                                </div>
                                {selectedInterview.meetingLink && (
                                    <div className="d-flex justify-content-between">
                                        <span className="fw-bold text-secondary">Meeting Link: </span>
                                        <a
                                            href={selectedInterview.meetingLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-dark text-decoration-none"
                                        >
                                            {selectedInterview.meetingLink}
                                        </a>
                                    </div>
                                )}

                                <div className="d-flex justify-content-between">
                                    <span className="fw-bold text-secondary">Status:</span>
                                    <Badge
                                        bg={selectedInterview.status === "accepted" ? "success"
                                            : selectedInterview.status === "scheduled" ? "warning"
                                                : "danger"}
                                    >
                                        {selectedInterview.status}
                                    </Badge>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="p-0 border-0">
                    {selectedInterview?.meetingLink && (
                        <a
                            href={selectedInterview.meetingLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-100 mx-3 mb-2 btn btn-primary text-center"
                        >
                            Join Meeting
                        </a>
                    )}
                    <Button variant="danger" className="w-100 mx-3 mb-2" onClick={() => setShowViewModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default Interviews;